<template>
  <div class="aspect-video w-full rounded-lg overflow-hidden bg-gray-100">
    <NuxtImg
      :aspect-ratio="imageAspectRatio"
      preload
      :src="String(image)"
      :alt="imageAlt"
      class="w-full h-full object-cover"
      loading="eager"
      width="800"
      height="450"
    />
  </div>
</template>
<script>
export default {
  name: 'MagazineArticleHeaderImage',
  props: {
    image: {
      type: String,
    },
    imageAlt: {
      type: String,
      default: '',
    },
    imageAspectRatio: {
      type: String,
      default: 'unset',
    },
  },
  setup(_props, _context) {
    return {}
  },
  data() {
    return {
      isMounted: false,
    }
  },
  mounted() {
    this.isMounted = true
  },
}
</script>
